"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearMessages = exports.removeMessage = exports.addMessage = void 0;
const immer_1 = require("immer");
const gtm_1 = require("../../lib/gtm");
const DEFAULT_MESSAGE_DURATION = 10;
let currentId = 0;
const ADD_MESSAGE = "editorState.add_message";
const REMOVE_MESSAGE = "editorState.remove_message";
const CLEAR_MESSAGES = "editorState.clear_messages";
// Track the timeouts so if we overwrite ID's then we can clear the existing timeout.
const removeMessageTimeouts = {};
function addMessage(message) {
    function cancelTimeout() {
        window.clearTimeout(removeMessageTimeouts[message.id]);
        delete removeMessageTimeouts[message.id];
    }
    return dispatch => {
        var _a;
        const id = message.id || currentId++;
        dispatch(addMessageInternal(Object.assign(Object.assign({}, message), { id })));
        // Remove existing timeout.
        cancelTimeout();
        const timeoutId = window.setTimeout(() => {
            dispatch(removeMessage(id));
            cancelTimeout();
        }, ((_a = message.duration) !== null && _a !== void 0 ? _a : DEFAULT_MESSAGE_DURATION) * 1000);
        removeMessageTimeouts[message.id] = timeoutId;
    };
}
exports.addMessage = addMessage;
function addMessageInternal(message) {
    return {
        type: ADD_MESSAGE,
        message,
    };
}
function removeMessage(id) {
    return {
        type: REMOVE_MESSAGE,
        id,
    };
}
exports.removeMessage = removeMessage;
function clearMessages() {
    return {
        type: CLEAR_MESSAGES,
    };
}
exports.clearMessages = clearMessages;
const messageReducer = (0, immer_1.produce)((draft, action) => {
    if (draft === undefined) {
        return [];
    }
    switch (action.type) {
        case ADD_MESSAGE:
            // If this message is persistent and was already shown - do not show it again.
            if (!getMessageShown(action.message.id, action.message.persistance)) {
                // If this message is on a layer, only show it if no other messages are showing.
                if (!action.message.layer ||
                    !draft.find(message => action.message.layer === message.layer)) {
                    // If a message with this ID exists we want to update that one instead of adding a new one.
                    const currentIndex = draft.findIndex(message => message.id === action.message.id);
                    if (currentIndex === -1) {
                        draft.push(action.message);
                    }
                    else {
                        draft[currentIndex] = action.message;
                    }
                    setMessageShown(action.message.id, action.message.persistance);
                    (0, gtm_1.trackGtmEvent)({
                        event: "mapmaker.show-toast-message",
                        id: action.message.id,
                        type: action.message.type,
                        duration: action.message.duration,
                    });
                }
            }
            break;
        case REMOVE_MESSAGE:
            const messageIndex = draft.findIndex(message => message.id === action.id);
            draft.splice(messageIndex, 1);
            break;
        case CLEAR_MESSAGES:
            return [];
    }
});
exports.default = messageReducer;
// Persistent messages
const MESSAGE_PREFIX = "mm-message.";
const storageId = id => MESSAGE_PREFIX + id;
function getMessageShown(id, persistance = "none") {
    if (typeof id === "number") {
        return;
    }
    switch (persistance) {
        case "none":
            return false;
        case "session":
            return Boolean(sessionStorage.getItem(storageId(id)));
        case "persistent":
            return Boolean(localStorage.getItem(storageId(id)));
    }
}
function setMessageShown(id, persistance = "none") {
    if (typeof id === "number") {
        return;
    }
    switch (persistance) {
        case "none":
            return;
        case "session":
            sessionStorage.setItem(storageId(id), "1");
            return;
        case "persistent":
            localStorage.setItem(storageId(id), "1");
            return;
    }
}
//# sourceMappingURL=data:application/json;base64,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